import { queryOptions, useQuery } from "@tanstack/react-query";
import { apiFetch, ApiRequestError } from "./api-client";

export interface Session {
  user: { id: string; email: string; name?: string | null };
}

export const sessionQueryOptions = queryOptions({
  queryKey: ["session"] as const,
  queryFn: async (): Promise<Session | null> => {
    try {
      return await apiFetch<Session>("/api/me");
    } catch (err) {
      if (err instanceof ApiRequestError && err.status === 401) {
        return null;
      }
      throw err;
    }
  },
  staleTime: 60_000,
});

export function useSession() {
  return useQuery(sessionQueryOptions);
}
